import classNames from 'classnames';
import React, { useState } from 'react';
import * as styles from './KeyboardShortcutsModal.module.scss';
import Shortcut from './Shortcut';
import ShortcutRow from './ShortcutRow';
import ShortcutSection from './ShortcutSection';
import Button from '../components/Button';
import Modal, { ModalTitle } from '../components/Modal';

const heading1 = <h1>Heading 1</h1>;
const heading2 = <h2>Heading 2</h2>;
const orderedList = (
  <ol>
    <li>Ordered list</li>
  </ol>
);
const bulletList = (
  <ul>
    <li>Bullet list</li>
  </ul>
);
const checkList = (
  <ul data-checked={false}>
    <li>Check list</li>
  </ul>
);
const pre = <pre>Code block</pre>;
const blockquote = <blockquote>Blockquote</blockquote>;
const bold = <b>Bold</b>;
const italic = <i>Italic</i>;
const strikethrough = <s>Strikethrough</s>;
const code = <code>Inline code</code>;
const or = <div className={styles.orWrapper}>or</div>;

interface KeyboardShortcutsModalProps {
  close: () => void;
}

const KeyboardShortcutsModal = ({ close }: KeyboardShortcutsModalProps) => {
  const [isShowingMarkdown, setIsShowingMarkdown] = useState(true);

  return (
    <Modal width="auto">
      <div className={styles.container}>
        <ModalTitle close={close}>Keyboard Shortcuts</ModalTitle>
        <div className={styles.sections}>
          <div>
            <ShortcutSection title="Everywhere">
              <ShortcutRow name="Show this modal" keys="mod+/" />
              <ShortcutRow name="Focus search bar" keys="/" />
              <ShortcutRow name="Create new post" keys="shift+n" />
              <ShortcutRow name="Jump to post" keys="mod+k" />
            </ShortcutSection>
            <ShortcutSection title="Editing">
              <ShortcutRow name="Enter edit mode">
                <Shortcut keys="e" />
                {or}
                <Shortcut keys="i" />
              </ShortcutRow>
              <ShortcutRow name="Exit edit mode" keys="mod+enter" />
              <ShortcutRow name="Undo" keys="mod+z" />
              <ShortcutRow name="Redo" keys="mod+shift+z" />
              <ShortcutRow name="Remove formatting" keys="mod+option+0" />
              <ShortcutRow name="Add comment">
                <Shortcut keys="mod+option+m" />
                {or}
                <Shortcut keys="mod+option+a" />
              </ShortcutRow>
              <ShortcutRow name="Copy as markdown" keys="mod+shift+c" />
              <ShortcutRow name="Mention person" input="@" />
              <ShortcutRow name="Link to post" input="+" />
              <ShortcutRow name="Insert emoji" input=":" />
            </ShortcutSection>
          </div>
          <div>
            <ShortcutSection
              title="Formatting"
              headerNote={
                <div className={styles.sectionTabs}>
                  <Button
                    size="small"
                    onClick={() => setIsShowingMarkdown(true)}
                  >
                    <div
                      className={classNames(styles.sectionTab, {
                        [styles.active]: isShowingMarkdown,
                      })}
                    >
                      Markdown
                    </div>
                  </Button>
                  <Button
                    size="small"
                    onClick={() => setIsShowingMarkdown(false)}
                  >
                    <div
                      className={classNames(styles.sectionTab, {
                        [styles.active]: !isShowingMarkdown,
                      })}
                    >
                      Hotkeys
                    </div>
                  </Button>
                </div>
              }
            >
              {isShowingMarkdown ? (
                <>
                  <ShortcutRow post name={heading1} input="#" keys="space" />
                  <ShortcutRow post name={heading2} input="##" keys="space" />
                  <ShortcutRow
                    post
                    name={orderedList}
                    input="1."
                    keys="space"
                  />
                  <ShortcutRow post name={bulletList} input="-" keys="space" />
                  <ShortcutRow post name={checkList} input="[]" keys="space" />
                  <ShortcutRow post name={pre} input="```" keys="enter" />
                  <ShortcutRow post name={blockquote} input=">" keys="space" />
                  <ShortcutRow
                    post
                    name="Horizontal Rule"
                    input="---"
                    key="enter"
                  />
                  <ShortcutRow post name={bold} input="**content**" />
                  <ShortcutRow post name={italic} input="*content*" />
                  <ShortcutRow post name={strikethrough} input="~~content~~" />
                  <ShortcutRow post name={code} input="`code`" />
                </>
              ) : (
                <>
                  <ShortcutRow post name={heading1} keys="mod+option+1" />
                  <ShortcutRow post name={heading2} keys="mod+option+2" />
                  <ShortcutRow post name={orderedList} keys="mod+shift+7" />
                  <ShortcutRow post name={bulletList} keys="mod+shift+8" />
                  <ShortcutRow post name={checkList} keys="mod+shift+9" />
                  <ShortcutRow post name={bold} keys="mod+b" />
                  <ShortcutRow post name={italic} keys="mod+i" />
                  <ShortcutRow post name={strikethrough} keys="mod+option+x" />
                  <ShortcutRow name="Add link" keys="mod+k" />
                </>
              )}
            </ShortcutSection>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default KeyboardShortcutsModal;
